import { render, staticRenderFns } from "./CategoryListTable.vue?vue&type=template&id=883f0d42&scoped=true"
import script from "./CategoryListTable.vue?vue&type=script&lang=js"
export * from "./CategoryListTable.vue?vue&type=script&lang=js"
import style0 from "./CategoryListTable.vue?vue&type=style&index=0&id=883f0d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883f0d42",
  null
  
)

export default component.exports